import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { mobilePromotion, promotions, mobilePromotion2 } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center mv="15px">
          <CFImage src={mobilePromotion} w="90%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" w="100%" m="0 auto">
          <CFImage src={promotions} w="100%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
